module.exports = __webpack_public_path__ + "static/media/Hanuman-Da-Damdaar.9a8e499d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Hanuman-Da-Damdaar.jpg
// module id = 428
// module chunks = 0